import type { IconProps } from './types';
import './icons.css';

export default function DoubleArrowRight({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      className={`icon icon-double-arrow-right ${className || ''}`}
      fill="none"
    >
      <path stroke="currentColor" d="m5 6 4 4.5L5 15m7-9 4 4.5-4 4.5" />
    </svg>
  );
}
